export const BLUE = "blue";
export const GREEN = "green";
export const RED = "red";
export const BLACK = "black";
